<template>
  <div id="app">

    <kgu-header/>

    <div id="page">

      <router-view/>

      <div></div>

      <kgu-footer/>

    </div>

  </div>
</template>
<script>
//import KguNav from '@/components/KguNav.vue'
import KguHeader from '@/components/KguHeader.vue'
import KguFooter from '@/components/KguFooter.vue'

export default {
  name: 'app',

  components: {
    //KguNav,
    KguHeader,
    KguFooter,
  },
}
</script>
